import React from 'react'
import facebook from "../../assets/icons/facebook.svg"
import Linkedin from "../../assets/icons/linkedin.svg"
import X from "../../assets/icons/x.svg"

const SocialIcons = ({ className }: { className?: string }) => (
  <div className={className}>
    <a target='_blank' href="https://www.facebook.com/share/1GmExgWpzu/?mibextid=wwXIfr" rel="noopener noreferrer">
      <img className="cursor-pointer max-w-[21.71px] w-full footerIconsAnimation custom-glow-icons drop-shadow-custom-glow" src={facebook} alt="facebook" />
    </a>
    <a target='_blank' href="https://www.linkedin.com/company/armorydefense" rel="noopener noreferrer">
      <img className="cursor-pointer max-w-[21.71px] w-full footerIconsAnimation custom-glow-icons drop-shadow-custom-glow" src={Linkedin} alt="linkedin" />
    </a>
    <a target='_blank' href="https://x.com/armory_defense?s=11&t=XlalHXPSemLK_mgcQ_8WFg" rel="noopener noreferrer">
      <img className="cursor-pointer max-w-[21.71px] w-full footerIconsAnimation custom-glow-icons drop-shadow-custom-glow" src={X} alt="x" />
    </a>
  </div>
);

export default SocialIcons
